module.exports = __webpack_public_path__ + "media/images/zapier-cde983d5609c124c6ec269718ef32208.svg";